<template>
  <div class="home main-content">
    <MainHeader></MainHeader>
    <div class="content">
      <div class="file">
        <div class="file-item">
          <div class="file-title">Current sessions <div class="file-more"><Icon size="22" type="ios-archive" />Archive</div></div>
          <div class="file-not">很遗憾，您没有当前会话。</div>
        </div>
      </div>
      <div class="file">
        <div class="file-item">
          <div class="file-title">Current tenders <div class="file-more"><Icon size="22" type="ios-archive" />Archive</div></div>
          <div class="file-content">
            <div style="overflow: hidden" v-for="(value, vi) in dataList1" :key="vi">
              <div class="content-list-tip">{{value.classifiy_name}}</div>
              <div>
                <div class="content-list start"  v-for="(item, index) in value.activity" :key="index">
                  <div class="box-shadow"></div>
                  <div class="content-list-title start_color" :style="'background: ' + progressColor[item.curProgress]">
                    <div class="content-list-text">{{item.title}}</div>
                    <div class="content-list-desc">{{value.classifiy_name}}
                      <div class="content-list-address">
                        <Icon type="ios-pin" />{{item.pickup_address}}
                      </div>
                    </div>
                  </div>
                  <div class="content-list-box">
                    <div class="content-list-mid">
                      <div class="content-mid-left"  @click="onGoList(item)">
                        <img class="icon-right" src="../assets/images/icon-right.png">
                        <div v-if="item.type == 2">
                          <div  v-if="item.curProgress === 1">
                            <div class="top">申请订货</div>
                            <div class="bottom">{{item.place_order_start_time | unixToDate('MM/DD HH:mm')}} - {{item.place_order_end_time | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                          <div  v-if="item.curProgress === 2">
                            <div class="top">确认订货</div>
                            <div class="bottom">{{item.order_confirmation_start_time | unixToDate('MM/DD HH:mm')}} - {{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                          <div  v-if="item.curProgress === 3">
                            <div class="top">结果</div>
                            <div class="bottom">{{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                        </div>
                        <div v-if="item.type == 1">
                          <div  v-if="item.curProgress === 1">
                            <div class="top">竞拍</div>
                            <div class="bottom">{{item.place_order_start_time | unixToDate('MM/DD HH:mm')}} - {{item.place_order_end_time | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                          <div  v-if="item.curProgress === 2">
                            <div class="top">等待结果</div>
                            <div class="bottom">{{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}} - {{item.early_morning | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                          <div  v-if="item.curProgress === 3">
                            <div class="top">结果</div>
                            <div class="bottom">{{item.early_morning | unixToDate('MM/DD HH:mm')}}</div>
                          </div>
                        </div>
                      </div>
                      <div class="content-mid-order">
                        <div></div>
                      </div>
                      <div class="content-mid-right">
                        <div class="top">剩余时间</div>
                        <div class="bottom">
                          <span v-if="item.endTime.d > 0"><span style="font-weight: bold; font-size: 18px" >{{item.endTime.d}}</span>d</span>
                          <span v-if="item.endTime.h > 0"><span style="font-weight: bold; font-size: 18px">{{item.endTime.h}}</span>h</span>
                          <span v-if="item.endTime.m > 0"><span style="font-weight: bold; font-size: 18px" >{{item.endTime.m}}</span>m</span>
                        </div>
                      </div>
                    </div>
                    <div class="content-list-bottom">
                      <div class="content-bottom-left" v-if="item.type == 2 && item.curProgress === 1">
                        <div class="top">确认订货</div>
                        <div class="bottom">{{item.order_confirmation_start_time | unixToDate('MM/DD HH:mm')}} - {{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}}</div>
                      </div>
                      <div class="content-bottom-left" v-else-if="item.type == 2 && item.curProgress === 2">
                        <div class="top">结果</div>
                        <div class="bottom">{{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}}</div>
                      </div>
                      <div class="content-bottom-left" v-else>
                        <div class="top">结果</div>
                        <div class="bottom">{{item.order_confirmation_end_time | unixToDate('MM/DD HH:mm')}}</div>
                      </div>
                      <div class="content-bottom-right" :style="item.attend_total > 0? 'color:#2D6D52': 'color: red'">
                        <Icon type="md-reorder" size="18"/>
                        <span>{{item.attend_total || 0}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="time">
        <div class="time-tip">活动规定的时间是<span style="font-weight: bold">{{timeList[0].name}}</span></div>
        <div class="time-list">
          <div class="time-item" v-for="(item, index) in timeList" :key="index">
            <div class="time-name" :class="index == 0? 'active': ''">{{item.name}}</div>
            <div class="time-time">{{item.time}}</div>
            <div class="time-date">{{item.date}}</div>
          </div>
        </div>
      </div>
      <MainFooter></MainFooter>
    </div>
  </div>
</template>

<script>
import MainHeader from '../public/MainHeader'
import MainFooter from '../public/MainFooter'
import Core from '@/until/core'
import moment from 'moment'

export default {
  name: 'Home',
  data () {
    return {
      timeList: [
        {
          id: 'clockBJ',
          name: '北京时间',
          date: '',
          time: '',
          zone: +8
        },
        {
          id: 'clockELS',
          name: '俄罗斯时间',
          date: '',
          time: '',
          zone: +3
        },
        {
          id: 'clockNY',
          name: '纽约时间',
          date: '',
          zone: -5
        },
        {
          id: 'clockBL',
          name: '巴黎时间',
          date: '',
          time: '',
          zone: +2
        },
        {
          id: 'clockDJ',
          name: '东京时间',
          date: '',
          time: '',
          zone: +9
        },
        {
          id: 'clockXN',
          name: '悉尼时间',
          date: '',
          time: '',
          zone: +10
        }
      ],
      database: {
        list1: [],
        list2: [],
        list3: []
      },
      progressColor: ['#95aed0', '#8ce6b0', '#ffd77a', '#ffb08f']
    }
  },
  computed: {
    dataList1 () {
      const data = this.database.list1
      for (const value of data) {
        if (value.activity && value.activity.length > 0) {
          for (const item of value.activity) {
            console.log(item)
            item.curProgress = 0
            let cTime = Date.now() / 1000
            let endTime = 0
            const result = {
              d: 0,
              h: 0,
              m: 0
            }
            // 计算当前活动进度
            if (parseInt(item.type) === 2) {
              if (cTime < parseInt(item.place_order_start_time)) {
                // 未开始
                endTime = 0
              } else if (cTime >= parseInt(item.place_order_start_time) && cTime < parseInt(item.place_order_end_time)) {
                // 申请订货
                item.curProgress = 1
                endTime = parseInt(item.place_order_end_time)
              } else if (cTime >= parseInt(item.order_confirmation_start_time) && cTime < parseInt(item.order_confirmation_end_time)) {
                // 确认订货
                item.curProgress = 2
                endTime = parseInt(item.order_confirmation_end_time)
              } else if (cTime >= parseInt(item.order_confirmation_end_time)) {
                // 已经结束
                item.curProgress = 3
              }
              if (endTime) {
                const rTime = parseInt(endTime) - cTime
                result.d = Math.floor(rTime / 86400)
                result.h = Math.floor((rTime - 86400 * result.d) / 3600)
                result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
              }
            } else if (parseInt(item.type) === 1) {
              if (cTime < parseInt(item.place_order_start_time)) {
                // 未开始
                endTime = 0
              } else if (cTime >= parseInt(item.place_order_start_time) && cTime < parseInt(item.place_order_end_time)) {
                // 竞拍阶段
                item.curProgress = 1
                endTime = parseInt(item.place_order_end_time)
              } else if (cTime >= parseInt(item.place_order_end_time) && cTime < parseInt(item.early_morning)) {
                // 等待结果
                item.curProgress = 2
                endTime = parseInt(item.early_morning)
              } else if (cTime >= parseInt(item.early_morning)) {
                // 已经结束
                item.curProgress = 3
              }
              if (endTime) {
                const rTime = parseInt(endTime) - cTime
                result.d = Math.floor(rTime / 86400)
                result.h = Math.floor((rTime - 86400 * result.d) / 3600)
                result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
              }
            } else {
              if (item.end_time) {
                const rTime = parseInt(item.end_time) - cTime
                result.d = Math.floor(rTime / 86400)
                result.h = Math.floor((rTime - 86400 * result.d) / 3600)
                result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
              }
            }
            item.endTime = result
          }
        }
      }
      return data
    },
    dataList () {
      const data = this.database.list1
      for (const item of data) {
        item.curProgress = 0
        let cTime = Date.now() / 1000
        let endTime = 0
        const result = {
          d: 0,
          h: 0,
          m: 0
        }
        // 计算当前活动进度
        if (parseInt(item.type) === 2) {
          if (cTime < parseInt(item.place_order_start_time)) {
            // 未开始
            endTime = 0
          } else if (cTime >= parseInt(item.place_order_start_time) && cTime < parseInt(item.place_order_end_time)) {
            // 申请订货
            item.curProgress = 1
            endTime = parseInt(item.place_order_end_time)
          } else if (cTime >= parseInt(item.order_confirmation_start_time) && cTime < parseInt(item.order_confirmation_end_time)) {
            // 确认订货
            item.curProgress = 2
            endTime = parseInt(item.order_confirmation_end_time)
          } else if (cTime >= parseInt(item.order_confirmation_end_time)) {
            // 已经结束
            item.curProgress = 3
          }
          if (endTime) {
            const rTime = parseInt(endTime) - cTime
            result.d = Math.floor(rTime / 86400)
            result.h = Math.floor((rTime - 86400 * result.d) / 3600)
            result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
          }
        } else if (parseInt(item.type) === 1) {
          if (cTime < parseInt(item.place_order_start_time)) {
            // 未开始
            endTime = 0
          } else if (cTime >= parseInt(item.place_order_start_time) && cTime < parseInt(item.place_order_end_time)) {
            // 竞拍阶段
            item.curProgress = 1
            endTime = parseInt(item.place_order_end_time)
          } else if (cTime >= parseInt(item.place_order_end_time) && cTime < parseInt(item.early_morning)) {
            // 等待结果
            item.curProgress = 2
            endTime = parseInt(item.early_morning)
          } else if (cTime >= parseInt(item.early_morning)) {
            // 已经结束
            item.curProgress = 3
          }
          if (endTime) {
            const rTime = parseInt(endTime) - cTime
            result.d = Math.floor(rTime / 86400)
            result.h = Math.floor((rTime - 86400 * result.d) / 3600)
            result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
          }
        } else {
          if (item.end_time) {
            const rTime = parseInt(item.end_time) - cTime
            result.d = Math.floor(rTime / 86400)
            result.h = Math.floor((rTime - 86400 * result.d) / 3600)
            result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
          }
        }
        item.endTime = result
      }
      return data
    },
    remainingTime () {
      const result = {
        d: 0,
        h: 0,
        m: 0
      }
      if (!this.database.list1 || this.database.list1.length <= 0) {
        return {}
      }
      console.log(parseInt(this.database.list1[0].end_time))
      const rTime = parseInt(this.database.list1[0].end_time) - (Date.now() / 1000)
      result.d = Math.floor(rTime / 86400)
      result.h = Math.floor((rTime - 86400 * result.d) / 3600)
      result.m = Math.floor((rTime - 86400 * result.d - 3600 * result.h) / 60)
      return result
    }
  },
  methods: {
    onGoList (item) {
      if (parseInt(item.type) === 1) {
        this.$router.push({name: 'List', query: {id: item.id}})
      } else if (parseInt(item.type) === 2) {
        this.$router.push({name: 'ListOrder', query: {id: item.id}})
      }
    },
    goPage () {
      this.$router.push({
        name: 'List'
      })
    },
    getList (type) {
      Core('/Auction/AuctionActivity/ActivityListnew', {type}).then(res => {
        if (res.data && res.data.list) {
          this.database['list' + type] = res.data.list
        }
      })
    },
    setTime () {
      const data = this.timeList
      for (const item of data) {
        item.date = this.calcTime(item.zone).date
        item.time = this.calcTime(item.zone).time
      }
    },
    calcTime (offset) {
      var d = new Date()
      var utc = d.getTime() + (d.getTimezoneOffset() * 60000)
      var nd = new Date(utc + (3600000 * offset))
      var mo = nd.getMonth()
      var day = nd.getDate()
      var h = nd.getHours()
      var m = nd.getMinutes()
      var s = nd.getSeconds()
      h = this.checkTime(h)
      m = this.checkTime(m)
      s = this.checkTime(s)
      return {date: mo + 1 + '月' + day + '日', time: h + ':' + m + ':' + s}
    },
    checkTime (i) {
      if (i < 10) { i = '0' + i }
      return i
    }
  },
  filters: {
    unixToDate (unix, format, defValue) {
      if (/\d{13}/.test(unix)) {
        unix = parseInt(unix / 1000, 10)
      }
      let date = moment(/\d{10}/.test(unix) ? moment.unix(unix) : '').format(format || 'YYYY-MM-DD HH:mm:ss')
      return date === 'Invalid date' ? (defValue || '---') : date
    }
  },
  components: {
    MainHeader,
    MainFooter
  },
  mounted () {
    this.getList(1)
    this.getList(2)
    // this.getList(3)
    this.setTime()
    setInterval(() => {
      this.setTime()
    }, 1000)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .content{width: 100%; min-width: 800px; max-width: 1200px; padding: 30px 0; margin: 0 auto}
  .file{margin-bottom: 40px}
  .file-title{width: 100%; border-bottom: 2px solid rgb(112, 194, 175);line-height: 30px; text-align: center; font-size: 16px; font-weight: bold;position: relative}
  .file-more{float: right; color: rgb(51, 122, 183);}
  .file-not{margin: 30px 0; line-height: 50px; text-align: center; border: 1px solid rgb(250, 233, 198); border-radius: 3px; background: rgb(238, 240, 242); color: rgb(135, 105, 88)}

  .content-list-tip{width: 200px; text-align: center; margin: 20px; margin-top: 30px; background: rgb(238, 240, 242); border: 1px solid #dcdee2; line-height: 30px; border-radius:50px}
  .content-list{width: 350px; height: 235px; background: #fff; float: left; border-radius: 8px; overflow: hidden; margin: 20px; box-shadow:0 0 5px #333333; cursor: pointer; position: relative}
  .box-shadow{width: 80%; height: 90%;  position: absolute; box-shadow:0 0 10px #999; transform: translateY(5%); z-index: -1}
  .content-list-title{background: rgb(227, 191, 155); padding: 0 20px;}
  .content-list-text{text-align: center; font-size: 18px; font-weight: bold; line-height: 45px; font-weight: bold; border-bottom: 1px dashed  rgb(39, 60, 89); }
  .content-list-desc{line-height: 40px; font-weight: bold;}
  .content-list-address{float: right}
  .start_color{background: rgb(149, 174, 208); color: rgb(39, 60, 89)}
  .soon_color{background: rgb(110, 193, 174); color: rgb(45, 109, 82)}
  .end_color{background: rgb(227, 191, 155); color: rgb(85, 84, 22)}
  .content-list-box{padding: 10px 0}
  .content-list-item{box-sizing: border-box; padding: 5px 10px}

  .time{background: rgb(239, 240, 242); border: 1px solid rgb(223, 235, 237); color: #787c7e; padding:10px 20px;
    border-radius: 5px; margin: 30px 0; font-size: 14px;}
  .time-tip{text-align: center; margin-bottom: 10px; font-size: 15px}
  .time-list{display: flex; width: 100%}
  .time-item{text-align: center; flex: 1;}
  .time-name.active{font-weight: bold}
  .time-name{ color: rgb(53, 110, 140); font-size: 16px}
  .time-time{font-weight: bold; color: rgb(103, 105, 105)}
  .time-date{olor: rgb(103, 105, 105)}

  .content-list-box{padding: 0 5px}
  .content-list-mid{display: flex;}
  .content-mid-left{flex: 1; display: flex; padding: 15px 0}
  .content-mid-left .icon-right{width: 18px; height: 18px; margin: 5px 10px}
  .content-mid-left .top {font-size: 18px; font-weight: bold;}
  .content-mid-left .bottom {font-size: 12px}
  .content-mid-order{padding: 5px 0;width: 1px;}
  .content-mid-order div{width: 0; height: 100%; border-left: 1px dashed rgb(126, 109, 115);}
  .content-mid-right{width: 120px; text-align: center; color: rgb(126, 109, 115);
    background: linear-gradient(to right, rgb(239, 240, 240), #fff);padding: 15px 0}
  .content-list-bottom{display: flex; border-top: 1px solid #ccc}
  .content-bottom-left{flex: 1; padding: 15px 36px}
  .content-bottom-left .bottom{font-size: 13px}
  .content-bottom-right{width: 90px; text-align: center; font-size: 13px; color: rgb(45, 109, 82); padding-top: 25px}

</style>



// WEBPACK FOOTER //
// src/components/Home.vue